import { Menu } from "@/shared/components/Menu";

import { RobotoMenuItem } from "../RobotoMenuItem";

import { MenuOptions } from "./MenuOptions";

interface ContextMenuProps {
  anchorEl: HTMLElement | null;
  isOpen: boolean;
  onClose: () => void;
  options: MenuOptions[];
}

export function ContextMenu(props: ContextMenuProps) {
  const { anchorEl, isOpen: open, onClose, options } = props;

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      {options.map((option) => (
        <RobotoMenuItem
          disableRipple
          eventName={option.eventName}
          eventProperties={option.eventProperties}
          key={option.label}
          onClick={() => {
            void option.onClick();
          }}
          sx={{
            gap: 1,
            ...option.style,
          }}
        >
          {option.icon}
          {option.label}
        </RobotoMenuItem>
      ))}
    </Menu>
  );
}
